module.exports = __webpack_public_path__ + "img/logo.5e1c87e2.png";